import React, { useContext, useState, useEffect, useRef } from 'react'
import './HomeNavLinks.css'
import { NavLink, Link } from 'react-router-dom'
import { AuthContext } from '../../context/auth-context'
//import NavLinksHomeDropdown from '../../../admin/components/NavLinksHomeDropdown'

const HomeNavLinks = (props) => {
	//const [isHomeMenuDropDownOpen, setHomeMenuDropDownOpen] = useState(false)
	console.log('inside HomeNavLinks: ' + props.leagueId)
	const auth = useContext(AuthContext)
	const propsString = props.leagueId

	let page

	if (auth.isLoggedIn) {
		//console.log('User is logged in!')
		page = '/admin/leagues/current'
	} else {
		//console.log('User is NOT logged in!')
		page = '/admin/login'
	}
	//
	//
	//****************************************************************************** */
	//
	//  Home dropdown menu stuff
	//
	//
	//****************************************************************************** */
	/* const closeHoverHomeMenu = () => {
		setHomeMenuDropDownOpen(false)
	}
	const homeDropdownRef = useRef(null)
	useHomeOnHoverOutside(homeDropdownRef, closeHoverHomeMenu) // Call the hook

	function useHomeOnHoverOutside(ref, handler) {
		useEffect(() => {
			const listener = (event) => {
				if (!ref.current || ref.current.contains(event.target)) {
					return
				}
				handler(event)
			}
			document.addEventListener('mouseover', listener)
			return () => {
				document.removeEventListener('mouseout', listener)
			}
		}, [ref, handler])
	} */

	return (
		<ul className='home-nav-links'>
			{/* <li>
				<NavLink to={`https://usaballhockey.com/future-stars-invitational/`}>
					HOME
				</NavLink>
			</li> */}
			{/* <li>
				<a href='/'>HOME</a>
			</li> */}
			<li>
				<NavLink to={'/schedule'}>SCHEDULE</NavLink>
			</li>
			{props.leagueId && (
				<li>
					<NavLink to={`/league/${propsString}`}>STANDINGS/ROSTERS</NavLink>
				</li>
			)}
			{props.leagueId && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/league/scoring/${propsString}`}>
						SCORING LEADERS
					</NavLink>
				</li>
			)}
			{!props.leagueId && (
				<li>
					<NavLink to={'/statsandstandings'}>STANDINGS/ROSTERS</NavLink>
				</li>
			)}
			{!props.leagueId && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/scoringleaders`}>SCORING LEADERS</NavLink>
				</li>
			)}
			<li>
				<NavLink to={page}>ADMIN</NavLink>
			</li>
		</ul>
	)
}

export default HomeNavLinks
